import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import Fragment from "../Fragment";

const FRAGMENT_COMPONENTS = ['Fragment', 'ModalFragment'];
export default function findFragmentParent(e: DceHTMLElement): Fragment{

    if(!e.parentDceElement || !e.ext){
        return null;
    }

    for (const fc of FRAGMENT_COMPONENTS) {
        if(e.parentDceElement.ext.getInitializedComponents().indexOf(fc) > -1){
            return e.parentDceElement.ext.getComponent(fc) as Fragment;
        }
    }

    return findFragmentParent(e.parentDceElement);
}
